var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownFlat(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5008 14.5616L-0.000113368 1.06066L1.06055 0L14.5615 13.5009L13.5008 14.5616Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9996 1.06182L13.4986 14.5627L12.438 13.5021L25.9389 0.00115589L26.9996 1.06182Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFlat);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyNyAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjUwMDggMTQuNTYxNkwtMC4wMDAxMTMzNjggMS4wNjA2NkwxLjA2MDU1IDBMMTQuNTYxNSAxMy41MDA5TDEzLjUwMDggMTQuNTYxNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjYuOTk5NiAxLjA2MTgyTDEzLjQ5ODYgMTQuNTYyN0wxMi40MzggMTMuNTAyMUwyNS45Mzg5IDAuMDAxMTU1ODlMMjYuOTk5NiAxLjA2MTgyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { ForwardRef as ReactComponent };